<template>
  <VaModal
    max-width="530px"
    :mobile-fullscreen="false"
    hide-default-actions
    model-value
    close-button
    @update:modelValue="emits('cancel')"
  >
    <h1 class="va-h5 mb-4">Thay đổi mật khẩu</h1>

    <VaForm ref="form" class="space-y-6" @submit.prevent="submit">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <VaValue v-slot="isPasswordVisible" :default-value="false">
          <VaInput
            v-model="oldPassword"
            :rules="[validators.required]"
            label="Mật khẩu cũ"
            placeholder="Mật khẩu cũ"
            required-mark
            :type="isPasswordVisible.value ? 'text' : 'password'"
            @clickAppendInner.stop="isPasswordVisible.value = !isPasswordVisible.value"
          >
            <template #appendInner>
              <VaIcon
                :name="isPasswordVisible.value ? 'mso-visibility_off' : 'mso-visibility'"
                class="cursor-pointer"
                color="secondary"
              />
            </template>
          </VaInput>
        </VaValue>

        <div class="hidden md:block" />
        <VaValue v-slot="isPasswordVisible" :default-value="false">
          <VaInput
            v-model="newPassword"
            :rules="[validators.required, validators.maxLength(30)]"
            label="Mật khẩu mới"
            placeholder="Mật khẩu mới"
            required-mark
            :type="isPasswordVisible.value ? 'text' : 'password'"
            @clickAppendInner.stop="isPasswordVisible.value = !isPasswordVisible.value"
          >
            <template #appendInner>
              <VaIcon
                :name="isPasswordVisible.value ? 'mso-visibility_off' : 'mso-visibility'"
                class="cursor-pointer"
                color="secondary"
              />
            </template>
          </VaInput>
        </VaValue>
        <VaValue v-slot="isPasswordVisible" :default-value="false">
          <VaInput
            v-model="repeatNewPassword"
            :rules="[validators.required, validators.maxLength(30)]"
            label="Nhập lại Mật khẩu mới"
            placeholder="Nhập lại Mật khẩu mới"
            required-mark
            :type="isPasswordVisible.value ? 'text' : 'password'"
            @clickAppendInner.stop="isPasswordVisible.value = !isPasswordVisible.value"
          >
            <template #appendInner>
              <VaIcon
                :name="isPasswordVisible.value ? 'mso-visibility_off' : 'mso-visibility'"
                class="cursor-pointer"
                color="secondary"
              />
            </template>
          </VaInput>
        </VaValue>
      </div>

      <div class="flex flex-col space-y-2">
        <div class="flex space-x-2 items-center">
          <VaIcon :name="newPassword?.length! >= 8 ? 'mso-check' : 'mso-close'" color="secondary" size="20px" />
          <p>Tối thiểu 8 ký tự</p>
        </div>
      </div>

      <div class="flex flex-col-reverse md:justify-end md:flex-row md:space-x-4">
        <VaButton :style="buttonStyles" preset="secondary" color="secondary" @click="emits('cancel')"> Hủy </VaButton>
        <!-- chỉ submit qua type submit, không dùng @click -->
        <VaButton :style="buttonStyles" class="mb-4 md:mb-0" type="submit"> Cập nhật </VaButton>
      </div>
    </VaForm>
  </VaModal>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useForm } from 'vuestic-ui'
import { buttonStyles } from '../styles'
import { validators } from '@/util/utils'
import { showError, showSuccess } from '@/util/toast'
import axios from 'axios'
import { apiChangePassword } from '@/services/userService'

const oldPassword = ref<string>('')
const newPassword = ref<string>('')
const repeatNewPassword = ref<string>('')

const { validate } = useForm('form')
const emits = defineEmits(['cancel'])

const submit = async () => {
  // check mật khẩu mới trùng nhau
  if (newPassword.value !== repeatNewPassword.value) {
    showError('Nhập lại Mật khẩu mới không trùng. Kiểm tra lại')
    return
  }

  // validate form
  if (!(await validate())) return

  try {
    // Call API đổi mật khẩu
    await apiChangePassword(oldPassword.value, newPassword.value)

    showSuccess('Thay đổi mật khẩu thành công')
    emits('cancel')
  } catch (err: any) {
    console.log(err)
  }
}
</script>

<style lang="scss">
.va-modal__inner {
  min-width: 326px;
}
</style>
